module.exports = __webpack_public_path__ + "static/img/refundAmount.00d53955.png";